<template>
  <b-modal
    id="my-modal"
    ref="myModal"
    title="Alterar status"
    @hide="resetForm"
    hide-footer
  >
    <div v-if="contentLoaded">
      <div class="row mb-4">
        <div class="col-md-12">
          <label>Status</label>
          <div class="input-group">
            <SelectProposalStatuses
              :first="'Todos'"
              :selected="proposal.status_id"
              class="form-control-sm"
              @change="proposal.status_id = $event"
            />
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-6">
          <b-button variant="primary" @click="handleSubmit">Salvar</b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SelectProposalStatuses from '@/components/forms/SelectProposalStatuses';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'CustomerProposalStatusModal',
  mixins: [returnMessageMixin],
  components: { SelectProposalStatuses },
  data() {
    return {
      proposal: null,
      contentLoaded: false,
    };
  },
  methods: {
    openModal() {
      this.$bvModal.show('my-modal');
    },
    closeModal() {
      this.$emit('updateList');
      this.$bvModal.hide('my-modal');
    },
    resetForm() {
      this.contentLoaded = false;
    },
    setContent(proposal) {
      this.proposal = proposal;
      this.contentLoaded = true;
    },
    handleSubmit() {
      const url = `${baseApiUrl}/v1/proposal/save`;
      axios
        .post(url, this.proposal)
        .then((res) => {
          this.logMessage(res);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
      this.closeModal();
    },
  },
};
</script>

<style scoped>
/* Adicione seus estilos aqui, se necessário */
</style>
